import styled from 'styled-components';
import { StyledForecast } from '../Forecast.style';
import { getColor } from 'common/constants/_colors';
import { loadingAnimationKeyFrames } from 'components/base/Skeletons';

export const StyledForecastLoader = styled(StyledForecast)`
  box-sizing: border-box;
  padding: 2rem 0;
  background: ${getColor('white')};
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-between;

  & > header {
    color: ${getColor('shuttleGray')};
    font-size: 2rem;
    display: flex;
  }
  & > main {
    img {
      width: 90rem;
      filter: grayscale(100%);
      animation: ${loadingAnimationKeyFrames} 3.5s infinite;
    }
  }
`;
